import { render, staticRenderFns } from "./communication_channels.vue?vue&type=template&id=54d33e54&scoped=true"
import script from "./communication_channels.vue?vue&type=script&lang=js"
export * from "./communication_channels.vue?vue&type=script&lang=js"
import style0 from "./communication_channels.vue?vue&type=style&index=0&id=54d33e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d33e54",
  null
  
)

export default component.exports